import { useContext } from "react";

import Context from "../../../../../../context";
import useGetTransferPositions from "../../../../../../hooks/useGetTransferPositions";
import { useCustomInputForm } from "./useCustomInputForm";

// ----------------------------------------------------------------------

type Props = {
	id: string;
};

export const useGetInputsMethods = ({ id }: Props) => {
	const { state } = useContext(Context);
	const { positions } = useGetTransferPositions();

	const position = positions.find((i) => i.positionId === id);
	const selectedPosition = state.selectedPositions.find((i) => i.id === id);
	const { methods } = useCustomInputForm({
		maxShares: position?.titles ?? 0,
		maxValue: position?.amount ?? 0,
		defaultShares: selectedPosition?.shares,
		defaultAmount: (selectedPosition?.shares ?? 0) * (position?.localPrice ?? 0),
		currency: position?.localCurrency ?? ""
	});

	const onChangeShares = (value: string) => {
		methods.clearErrors("amount");
		methods.setValue(
			"amount",
			parseFloat(((parseFloat(value) || 0) * (position?.localPrice ?? 0)).toFixed(2))
		);
	};

	const onChangeValue = (value: number | null) => {
		methods.clearErrors("shares");
		methods.setValue("shares", parseFloat((value ?? 0).toFixed(4)));
	};

	return { onChangeValue, onChangeShares, methods };
};

export default useGetInputsMethods;
